import { PayinOrderStatus } from '~/entities/payin';

export const isConfirmEnabled = (status?: PayinOrderStatus) => {
    return (
        status === PayinOrderStatus.STATUS_MERCHANT_CONFIRMED ||
        status === PayinOrderStatus.STATUS_WAITING_FOR_PROOFS ||
        status === PayinOrderStatus.STATUS_WAITING_PROOFS_APPROVAL
    );
};
